export default __webpack_public_path__ + "assets/8e50462d7d8c953652c7cbc6b974817c.jpeg";